import React from 'react'
import logo from '../../../../assets/images/kinstak-logo01.jpg'

const HeaderLogo = ({ onClick, className = '', variant = 'default' }) => {
  const getLogoClasses = () => {
    const baseClasses = 'fluid-image'
    const variantClasses = {
      default: '',
      left: 'kinstak-logo-left',
      header: ''
    }

    return `${baseClasses} ${variantClasses[variant]} ${className}`.trim()
  }

  return (
    <div className="header-logo-container" onClick={onClick}>
      <img
        id={variant === 'default' ? 'logo-image' : undefined}
        src={logo}
        className={getLogoClasses()}
        alt="Kinstak logo."
      />
    </div>
  )
}

export default HeaderLogo
